<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1">CONTENTS</p>
<p class="TOC"><a href="#/Foreword">Foreword: More than 100 Years of History Makes Live Theater Key Part of Cape Cod’s Unique Identity, by Kathi Scrizzi Driscoll</a></p>
<p class="TOC"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="TOC1"><a href="#/Chapter1#C1">1. Sun, Surf and Spotlights: The Enduring World of Theater on Cape Cod</a></p>
<p class="TOC"><a href="#/Chapter2#C2">2. Provincetown: At the Land’s End Is the Beginning</a></p>
<p class="TOC"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Theater History on the Lower Cape: Drama and Music in the Dunes</span></p>
<p class="TOC"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Theater at the Elbow of the Cape: Dedication and Determination</span></p>
<p class="TOC"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. In the Middle of It All: Theater in the Mid-Cape Area</span></p>
<p class="TOC"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Theater in the Upper Cape: Near the Mainland but Worlds Away</span></p>
<p class="TOC"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Theater on the Islands: Drenched in History</span></p>
<p class="TOC"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. A Final Note</span></p>
<p class="TOC1"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?77f2e77c